import { render } from "./BkpExport.vue?vue&type=template&id=70c5a204"
import script from "./BkpExport.vue?vue&type=script&lang=js"
export * from "./BkpExport.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__